<template>
  <div class="language-switcher">
    <div class="dropdown">
      <button class="btn dropdown-toggle" type="button" id="languageDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-globe"></i> {{ currentLanguageDisplay }}
      </button>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
        <li v-for="lang in availableLanguages" :key="lang.code">
          <a class="dropdown-item" href="#" @click.prevent="changeLanguage(lang.code)" :class="{ active: currentLocale === lang.code }">
            {{ lang.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'LanguageSwitcher',
  setup() {
    // Access i18n instance using composition API
    const { locale } = useI18n()
    const router = useRouter()

    // Available languages
    const availableLanguages = [
      { code: 'en', name: 'English' },
      { code: 'ja', name: '日本語' }
    ]

    // Current locale
    const currentLocale = computed(() => locale.value)

    // Display name for current language
    const currentLanguageDisplay = computed(() => {
      const lang = availableLanguages.find(l => l.code === locale.value)
      return lang ? lang.name : 'English'
    })

    // Function to change the language
    const changeLanguage = (langCode) => {
      if (langCode === locale.value) return

      // Save locale preference to localStorage
      localStorage.setItem('locale', langCode)

      // Update i18n locale
      locale.value = langCode

      // Update HTML lang attribute
      document.documentElement.setAttribute('lang', langCode)

      // Navigate to the translated route
      const currentRoute = router.currentRoute.value
      const pathSegments = currentRoute.path.split('/')

      // Skip the first empty segment and potentially the language code
      let newPath = ''
      let segmentIndex = 1

      // If current path has a language prefix, skip it
      if (['en', 'ja'].includes(pathSegments[1])) {
        segmentIndex = 2
      }

      // Build the new path with language prefix
      newPath = `/${langCode}`
      for (let i = segmentIndex; i < pathSegments.length; i++) {
        if (pathSegments[i]) {
          newPath += `/${pathSegments[i]}`
        }
      }

      // If we're at the root path with just a language code
      if (pathSegments.length <= 2 && ['en', 'ja'].includes(pathSegments[1])) {
        newPath = `/${langCode}`
      }

      // If we're at the root path with no language code
      if (currentRoute.path === '/') {
        newPath = `/${langCode}`
      }

      // Navigate to the new path
      if (currentRoute.path !== newPath) {
        router.push(newPath)
      } else {
        // If the path didn't change, refresh the page to update content
        window.location.reload()
      }
    }

    return {
      availableLanguages,
      currentLocale,
      currentLanguageDisplay,
      changeLanguage
    }
  }
}
</script>

<style scoped>
.language-switcher {
  margin-left: 1rem;
}
</style>